import { DashboardHome, Home, LandingPage, Technical } from './pages'
import { ContactSupprt, ForgotPassword, Login, ResetPassword } from './pages/auth'
import { Switch, BrowserRouter as Router } from 'react-router-dom'
import { AuthLayoutRoute, FormLayoutRoute, LandingLayoutRoute, LayoutRoute } from './pages/routes.js'

const Approute = () => {
    return (
        <Router>
            <Switch>
                <AuthLayoutRoute
                    path={"/login"}
                    exact={true}
                    Component={Login}
                />
                <AuthLayoutRoute
                    path={"/forgot-password"}
                    exact={true}
                    Component={ForgotPassword}
                />
                <AuthLayoutRoute
                    path={"/contact"}
                    exact={true}
                    Component={ContactSupprt}
                />
                <AuthLayoutRoute
                    path={"/reset-password"}
                    exact={true}
                    Component={ResetPassword}
                />
                <LandingLayoutRoute
                    path={"/"}
                    exact={true}
                    Component={LandingPage}
                />
                <FormLayoutRoute
                    path={"/application"}
                    exact={true}
                    Component={Home}
                />
                   <LayoutRoute
                    path={"/dashboard"}
                    exact={true}
                    Component={DashboardHome}
                />
                <LayoutRoute
                path={"/technical-test"}
                exact={true}
                Component={Technical}
                />
            </Switch>
        </Router>
    );
};

export default Approute;
